import type {PullRequestReviewInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'

function ChangesRequestedReviewText({info}: {info: PullRequestReviewInfo}) {
  const {qualifiedReviewer} = info
  return <>{qualifiedReviewer ? 'requested changes' : 'suggested changes'}</>
}

function DismissedText({info}: {info: PullRequestReviewInfo}) {
  const {dismissedState} = info
  if (dismissedState === 'approved') {
    return <>previously approved these changes</>
  } else if (dismissedState === 'changes_requested') {
    return <>previously requested changes</>
  } else {
    return <>dismissed this review</>
  }
}

const STATE_TEXT: Partial<Record<string, string>> = {
  approved: 'approved these changes',
  pending: 'started a review',
  commented: 'reviewed these changes',
}

export function PullRequestReviewText({info}: {info: PullRequestReviewInfo}) {
  const {state, reviewerType} = info

  if (reviewerType === 'code_scanning' || reviewerType === 'automated') {
    return <>found potential problems</>
  }

  if (state === 'dismissed') {
    return <DismissedText info={info} />
  }

  if (state === 'changes_requested') {
    return <ChangesRequestedReviewText info={info} />
  }

  return <>{STATE_TEXT[state] ?? <>reviewed</>}</>
}
